
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinjejuri() {



const cardData = {
  keyword: 'Cab Services in Jejuri MIDC Pune',
  heading: 'eTravo: Trusted and Efficient Corporate Cab Services in Jejuri MIDC Pune',
  headingDescription: 'eTravo provides comprehensive and reliable corporate cab services in Jejuri MIDC Pune, designed to meet the diverse transportation needs of industries, employees, and executives in this prominent industrial area. Our services emphasize safety, punctuality, and comfort, with a well-maintained fleet of GPS-enabled, air-conditioned vehicles and professional drivers who understand the unique logistics of Jejuri MIDC. From daily employee commutes to executive transfers and client pickups, eTravo offers tailored solutions that help businesses maintain smooth and efficient operations across Jejuri MIDC and nearby regions.',

  top: 'Key Industrial and Corporate Locations in Jejuri MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Jejuri Industrial Park',
      description: 'Home to numerous manufacturing units and industrial firms, this park requires dependable transport for its workforce and visiting officials. eTravo ensures timely pick-ups and drop-offs to support operational efficiency.'
    },
    {
      title: 'Corporate Offices in Jejuri MIDC',
      description: 'Various companies have set up their administrative and management offices here, necessitating professional and comfortable transportation options for their staff and visiting clients.'
    },
    {
      title: 'Logistics and Warehousing Centers',
      description: 'Efficient cab services catering to logistics personnel and supervisors, facilitating seamless movement of teams managing goods and inventory across the industrial complex.'
    },
    {
      title: 'Nearby Employee Residential Areas',
      description: 'Reliable transport connections between residential neighborhoods and the industrial zone help reduce employee commute stress and improve punctuality.'
    },
    {
      title: 'Training and Skill Development Institutes',
      description: 'Supporting transport needs of trainees and instructors attending courses and workshops, fostering skill enhancement for local industry professionals.'
    },
    {
      title: 'Client Visit and Meeting Venues',
      description: 'Ensuring professional, timely, and comfortable travel for clients and business partners visiting factories and offices within Jejuri MIDC.'
    }
  ],

  services: [
    {
      name: 'Jejuri MIDC Corporate Cab Rentals',
      description: 'Flexible and customizable corporate cab rental plans tailored to fit your business requirements. Whether it’s long-term contracts or short-term needs, we provide vehicles and services that scale with your operations.'
    },
    {
      name: 'Employee Transport Cab Jejuri MIDC',
      description: 'Daily and shift-based transport for employees, designed to ensure timely pick-ups and drops with GPS tracking and real-time updates for safety and reliability.'
    },
    {
      name: 'Business Cab Services Jejuri MIDC',
      description: 'Professional cab services for business owners, field executives, and client visits, offering a diverse fleet including sedans and SUVs to match your corporate image.'
    },
    {
      name: 'Corporate Staff Cabs Jejuri MIDC',
      description: 'Dedicated cabs for staff with multi-stop routes and shift-wise scheduling, improving employee satisfaction by providing punctual and hassle-free transport.'
    },
    {
      name: 'Reliable Corporate Cab Service Jejuri MIDC',
      description: 'Trusted by companies across Jejuri MIDC for punctuality, well-maintained vehicles, and courteous drivers who prioritize safety and comfort.'
    },
    {
      name: 'AC Corporate Cabs Jejuri MIDC',
      description: 'Fully air-conditioned, sanitized vehicles that guarantee a comfortable and refreshing journey even during the hot and humid months, ensuring employee well-being.'
    },
    {
      name: 'Staff Pickup and Drop Cab Jejuri MIDC',
      description: 'Round-the-clock scheduled pickups and drops tailored to your shift timings and operational needs, maximizing productivity and reducing employee commute-related stress.'
    },
    {
      name: 'Affordable Business Cab Rentals Jejuri MIDC',
      description: 'Competitive pricing models with flexible billing and  options, ideal for businesses looking to optimize their transportation budgets without compromising on quality.'
    },
    {
      name: 'Executive Cab Services Jejuri MIDC',
      description: 'Premium cab offerings for executives and VIP clients featuring luxury vehicles, professional chauffeurs, and an emphasis on privacy and punctuality.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Jejuri MIDC',
      description: 'Comprehensive monthly plans offering fixed routes, real-time vehicle tracking, and dedicated customer support to ensure seamless corporate transportation.'
    },
    {
      name: 'Industrial Area Employee Transport Jejuri MIDC',
      description: 'Complete transportation management for industrial employees, including multi-stop routing and shift coordination to streamline daily commutes.'
    },
    {
      name: 'Corporate Client Cabs Jejuri MIDC',
      description: 'Professional and comfortable transportation services for visiting clients, ensuring their travel experience reflects the professionalism of your company.'
    },
    {
      name: 'Business Meeting Cabs Jejuri MIDC',
      description: 'On-demand and scheduled cab services for business meetings, allowing your team to travel flexibly and efficiently within Jejuri MIDC and its surroundings.'
    },
    {
      name: 'Jejuri Industrial Area Cab Hire',
      description: 'Dedicated cab hire options for special corporate events, inter-office transfers, and daily commutes with a focus on reliability and safety.'
    },
    {
      name: 'Corporate Shuttle Cabs Jejuri MIDC',
      description: 'Group shuttle services designed to transport teams smoothly across industrial zones, transit hubs, and nearby residential areas, enhancing operational coordination.'
    }
  ],

  tableData: [
    ['Jejuri MIDC Corporate Cab Rentals', 'Employee Transport Cab Jejuri MIDC'],
    ['Business Cab Services Jejuri MIDC', 'Corporate Staff Cabs Jejuri MIDC'],
    ['Reliable Corporate Cab Service Jejuri MIDC', 'AC Corporate Cabs Jejuri MIDC'],
    ['Staff Pickup and Drop Cab Jejuri MIDC', 'Affordable Business Cab Rentals Jejuri MIDC'],
    ['Executive Cab Services Jejuri MIDC', 'Monthly Corporate Cab Rentals Jejuri MIDC'],
    ['Industrial Area Employee Transport Jejuri MIDC', 'Corporate Client Cabs Jejuri MIDC'],
    ['Business Meeting Cabs Jejuri MIDC', 'Jejuri Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Jejuri MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Tailored Corporate Cab Services for Jejuri MIDC Pune",
        "WhyChoosedescription": "eTravo specializes in providing customized corporate cab services for businesses in Jejuri Industrial Area MIDC, Pune. We understand the unique commuting challenges faced by companies in this region and offer dependable, punctual, and comfortable transportation solutions that improve employee satisfaction and operational efficiency. Our services are crafted to support seamless daily commutes, client visits, and inter-office travel with utmost reliability."
    },
    {
        "WhyChooseheading": "Diverse Fleet Options Catering to All Corporate Needs",
        "WhyChoosedescription": "Our fleet comprises a wide variety of vehicles including sedans, SUVs, and MUVs, allowing companies to choose the ideal vehicle type based on their employee count, comfort preferences, and travel requirements. Whether for daily commuting or executive travel, we have the right vehicle to suit your needs."
    },
    {
        "WhyChooseheading": "Experienced Drivers with In-depth Knowledge of Jejuri MIDC Routes",
        "WhyChoosedescription": "Our professional drivers possess thorough knowledge of Jejuri MIDC and the surrounding Pune industrial corridors. Their experience ensures timely pickups, efficient route navigation, and smooth rides, helping minimize delays and maximize productivity."
    },
    {
        "WhyChooseheading": "Flexible Booking and Scheduling to Fit Corporate Timelines",
        "WhyChoosedescription": "We offer flexible booking options such as on-demand rides, advance scheduling, and long-term contracts. This adaptability helps businesses manage transportation effectively according to varying shift patterns, project deadlines, and employee needs."
    },
    {
        "WhyChooseheading": "Advanced Real-Time GPS Tracking for Safety and Transparency",
        "WhyChoosedescription": "Each vehicle is equipped with GPS tracking systems allowing clients to monitor rides live. This feature enhances passenger safety, provides transparency, and enables quick responses in case of any travel disruptions."
    },
    {
        "WhyChooseheading": "Transparent and Detailed Billing for Efficient Financial Management",
        "WhyChoosedescription": "Our billing process is fully transparent, providing detailed invoices including trip summaries and fare breakdowns. This simplifies expense management and reimbursement processes for corporate finance teams."
    },
    {
        "WhyChooseheading": "Stringent Safety and Hygiene Protocols Ensuring Passenger Wellbeing",
        "WhyChoosedescription": "Committed to passenger health, we maintain strict hygiene standards including regular vehicle sanitization, driver health checks, and adherence to mask mandates, providing a safe and comfortable travel environment."
    },
    {
        "WhyChooseheading": "Dedicated Corporate Account Management for Personalized Service",
        "WhyChoosedescription": "We assign a dedicated account manager to each corporate client to provide personalized assistance with bookings, handle queries promptly, and tailor transportation solutions that perfectly align with your business requirements."
    }
]
}

const faqData = [
    [
        {
            question: "What areas do your cab services cover in Jejuri MIDC Pune?",
            answer: "Our corporate cab services cover Jejuri Industrial Area MIDC along with surrounding industrial and commercial zones within Pune."
        },
        {
            question: "Can we schedule regular rides for our employees?",
            answer: "Yes, we provide options to schedule recurring rides ensuring consistent and reliable transportation."
        },
        {
            question: "Do you offer monthly billing for corporate clients?",
            answer: "Absolutely, we offer monthly billing cycles with detailed invoices for easy financial tracking."
        },
        {
            question: "Are your drivers trained to uphold corporate professionalism?",
            answer: "Yes, all our drivers undergo professional training to maintain high standards of courtesy, safety, and professionalism."
        },
        {
            question: "How do you ensure passenger safety during rides?",
            answer: "We implement GPS tracking, regular vehicle maintenance, and strict hygiene protocols including sanitization and mask usage."
        },
        {
            question: "Is there dedicated support for corporate clients in Jejuri MIDC?",
            answer: "Yes, corporate clients have access to dedicated account managers and support services for prompt assistance."
        }
    ]
];

const testimonialsData = [
    {
        name: "Mr. Ramesh Kulkarni",
        designation: "Operations Manager, Jejuri Manufacturing",
        rating: [1, 1, 1, 1, 1],
        text: "“eTravo’s services in Jejuri MIDC have provided our employees with safe, reliable, and comfortable transportation, significantly improving punctuality.”"
    },
    {
        name: "Ms. Sneha Patil",
        designation: "HR Executive, Sunrise Industries",
        rating: [1, 1, 1, 1, 1],
        text: "“The professionalism and flexibility offered by eTravo make them our go-to partner for corporate transportation needs.”"
    }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Services in Jejuri MIDC Pune",
  "image": "https://www.etravo.in/images/keyword/cab-service-jejuri-midc.jpg",
  "description": "Reliable corporate cab services in Jejuri MIDC Pune for employee transport, business meetings, and industrial area commutes. Affordable AC corporate cabs with trusted drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7812"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-services-jejuri-midc-pune"
  }
};








    return (
        <div>
<Helmet>
  <title>Cab Services in Jejuri MIDC Pune | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Jejuri MIDC Pune for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinjejuri;